import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import CarrierInfo from "../carrierInfo/CarrierInfo";
import Rates from "../rates/Rates";
import BoxRates from "../box-rates/BoxRates";
import LongDistance from "../long-distance/LongDistance";
import Insurance from "../insurance/Insurance";
import TravelTime from "../travel-time/TravelTime";
import TimeSlot from "../time-slot/TimeSlot";
import CarrierStats from "../carrier-stats/CarrierStats";
import AIBot from "../ai-bot/AIBot";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import InventoryPopulate from "../inventoryPopulate/InventoryPopulate";
import Billing from "../../components/billing/Billing";

interface ContentAreaProps {
  sidebarOpen: boolean;
  activeComponent: string;
  setActiveComponent: any;
}

const ContentArea: React.FC<ContentAreaProps> = ({
  sidebarOpen,
  activeComponent,
  setActiveComponent,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businessName } = useParams();
  const [carrier, setCarrier] = useState<any>(null);
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          setCarrier(res);
          // setCarrierEmail(res.email);
          if (res) {
            console.log(res);
          }
        })
        .catch((err: any) => {
          console.error("Failed to fetch carrier data:", err);
          navigate("/not-found");
        });
    }
  }, [businessName]);
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        pt: 8,
        textAlign: "left",
        ml: sidebarOpen ? "20px" : 0,
        transition: (theme) =>
          theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      {activeComponent === "CarrierInfo" && (
        <CarrierInfo setActiveComponent={setActiveComponent} />
      )}
      {activeComponent === "Rates" && <Rates />}
      {activeComponent === "BoxRates" && <BoxRates />}
      {activeComponent === "LongDistance" && <LongDistance />}
      {activeComponent === "Insurance" && <Insurance />}
      {activeComponent === "TravelTime" && <TravelTime />}
      {activeComponent === "TimeSlot" && <TimeSlot />}
      {activeComponent === "Stats" && <CarrierStats />}
      {activeComponent === "AIBot" && <AIBot />}
      {activeComponent === "SMS Inventory Tool" && (
        <InventoryPopulate
          setActiveComponent={setActiveComponent}
          carrier={carrier}
        />
      )}
      {activeComponent === "Billing" && <Billing carrier={carrier} />}
    </Box>
  );
};

export default ContentArea;
